// src/components/TableList.js
import React from "react";
import { Card } from "react-bootstrap";
import "../../../css/DBTablePage.css";

function TableList({ tables }) {
  return (
    <Card className="action-card h-100">
      <Card.Body>
        <Card.Title className="section-title">📋 Elenco tabelle presenti</Card.Title>
        <div className="table-list">
          {tables.length > 0 ? (
            tables.map((item) => (
              <div key={item.name} className="table-item">
                {item.name}
              </div>
            ))
          ) : (
            <p className="text-muted mb-0">Nessuna tabella trovata.</p>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default TableList;
